<template>
  <div id="app">
    <transition :name = "route">
      <router-view class="router" :key="$route.path + $route.params.id + $route.params.ch" />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      route: 'route'
    }
  },
  created() {
    if(window.location.href === "https://www.ztys.com.cn/wap/index.html"){
      this.$router.push({
        name: 'index'
      })
    }
  }
  // computed: {
  //     key() {
  //       // 只要保证 key 唯一性就可以了，保证不同页面的 key 不相同
  //       // console.log(this.$route.fullPath);
  //       return this.$route.fullPath
  //     }
  //   }

}
</script>

<style>
#app {
  overflow: hidden;
  font-family: '微软雅黑' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
*{margin: 0; padding: 0; font-family: '微软雅黑' !important;}
li{list-style: none;}
a{text-decoration: none;}
@font-face{
  font-family:myFont;
  src:url('./assets/font/LHF-Old-Block-CondMed.ttf')/*IE9+,可以是具体的实际链接*/
}
.router{ width: 100%;}
/* .route-enter-active { transition: all 1s ease;}
.route-leave-active { transition: all 1s ease;}
.route-enter{transform: translateX(10%); opacity: 0;}
.route-leave-to{transform: translateX(-10%); opacity: 0;} */
</style>



// WEBPACK FOOTER //
// src/App.vue